import { useRef } from 'react';

/**
 * Keep initial rendering time.
 */
export function useInitialRenderTime(): number {
  return useRef(Date.now()).current;
}
